/* ILTC theme scripts */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function updateQuoteCount(count) {
    var link = $('a[href$="/cart"].icon-btn') || $('a.icon-btn[aria-label^="Quote list"]');
    if (!link) return;
    var badge = $('[data-quote-count]', link);
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'count';
        badge.setAttribute('data-quote-count', '');
        link.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
    link.setAttribute('aria-label', 'Quote list, ' + count + ' items');
  }

  function refreshQuoteCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateQuoteCount(cart.items.length); })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    /* Header search */
    var searchToggle = $('[data-search-toggle]');
    var searchPanel = $('#HeaderSearch');
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function (e) {
        e.preventDefault();
        searchPanel.hidden = !searchPanel.hidden;
        if (!searchPanel.hidden) { var i = $('input[type="search"]', searchPanel); if (i) i.focus(); }
      });
    }

    /* Mobile menu */
    var menuToggle = $('[data-menu-toggle]');
    var mobileNav = $('#MobileNav');
    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', function () {
        var open = mobileNav.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
    }

    /* Hero search: a category on its own goes straight to that category */
    $all('[data-hero-search]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var cat = $('[data-hero-category]', form);
        var q = $('[data-hero-query]', form);
        if (cat && cat.value && q && !q.value.trim()) {
          e.preventDefault();
          window.location.href = cat.value;
        }
      });
    });

    /* Collection sort */
    $all('[data-sort-select]').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });

    /* Product gallery */
    $all('[data-gallery]').forEach(function (gallery) {
      var main = $('[data-gallery-main]', gallery) || $('.gallery__main img', gallery);
      $all('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.getAttribute('data-src');
          main.srcset = thumb.getAttribute('data-srcset');
          main.alt = thumb.getAttribute('data-alt') || '';
          $all('[data-gallery-thumb]', gallery).forEach(function (t) { t.removeAttribute('aria-current'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });

    /* Quote form: per-size quantities, total and minimum order */
    $all('[data-quote-form]').forEach(function (form) {
      var min = parseInt(form.getAttribute('data-min-order'), 10) || 0;
      var inputs = $all('[data-qty-input]', form);
      var totalEl = $('[data-qty-total]', form);
      var totalField = $('[data-qty-total-field]', form);
      var warning = $('[data-qty-warning]', form);
      var addBtn = $('[data-add-to-quote]', form);
      var status = $('[data-add-to-quote-status]', form);

      function total() {
        return inputs.reduce(function (sum, i) { return sum + (parseInt(i.value, 10) || 0); }, 0);
      }
      function refresh() {
        var t = total();
        if (totalEl) totalEl.textContent = t;
        if (totalField) totalField.value = t;
        if (warning && t > 0 && t >= min) warning.hidden = true;
      }
      function check() {
        var t = total();
        if (t === 0) {
          warning.textContent = 'Enter how many you want in at least one size.';
          warning.hidden = false;
          return false;
        }
        if (min && t < min) {
          warning.textContent = 'The minimum order is ' + min + ' units. You have ' + t + '.';
          warning.hidden = false;
          return false;
        }
        warning.hidden = true;
        return true;
      }
      inputs.forEach(function (i) { i.addEventListener('input', refresh); });
      refresh();

      form.addEventListener('submit', function (e) {
        if (!check()) { e.preventDefault(); if (inputs[0]) inputs[0].focus(); }
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (total() === 0) { check(); return; }
          if (warning) warning.hidden = true;
          var items = inputs
            .filter(function (i) { return (parseInt(i.value, 10) || 0) > 0; })
            .map(function (i) { return { id: parseInt(i.getAttribute('data-variant-id'), 10), quantity: parseInt(i.value, 10) }; });
          addBtn.disabled = true;
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
            .then(function (res) {
              status.hidden = false;
              if (res.ok) {
                status.className = 'form-message form-message--success';
                status.innerHTML = 'Added to your quote list. <a href="' + root + 'cart">View quote list</a>';
                refreshQuoteCount();
              } else {
                status.className = 'form-message form-message--error';
                status.textContent = res.data.description || res.data.message || 'Sorry, that didn’t work. Please try again.';
              }
            })
            .catch(function () {
              status.hidden = false;
              status.className = 'form-message form-message--error';
              status.textContent = 'Sorry, that didn’t work. Please try again.';
            })
            .finally(function () { addBtn.disabled = false; });
        });
      }
    });

    /* After a quote list is sent, empty it */
    if ($('[data-clear-cart]')) {
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function () { updateQuoteCount(0); })
        .catch(function () {});
    }

    /* Success messages: bring into view */
    var success = $('[data-autofocus]');
    if (success) { success.scrollIntoView({ block: 'center' }); success.focus({ preventScroll: true }); }

    /* Password recovery toggle */
    var recoverToggle = $('[data-recover-toggle]');
    var recoverPanel = $('[data-recover-panel]');
    if (recoverToggle && recoverPanel) {
      if (window.location.hash === '#recover' || recoverPanel.querySelector('.form-message')) recoverPanel.hidden = false;
      recoverToggle.addEventListener('click', function (e) {
        e.preventDefault();
        recoverPanel.hidden = !recoverPanel.hidden;
      });
    }
  });
})();
